export const vendooMeta = [
  { label: 'Role', value: 'Lead Product Designer, solo' },
  { label: 'Team', value: 'Founders + a small dev team' },
  { label: 'Timeline', value: '2020 to 2021' },
  { label: 'Tools', value: 'Figma, UXPin, Maze, Jira, Notion' },
];

export const marketplaces = ['eBay', 'Poshmark', 'Mercari', 'Etsy', 'Tradesy', 'Kidizen'];

export const vendooChallenges = [
  { title: 'Satisfied users', body: 'Most users liked the product, so useful criticism took digging.' },
  { title: 'Small team', body: 'Tight deadlines and limited resources.' },
  { title: 'No design process', body: 'I created one and tested it with the founders.' },
  { title: 'Few metrics', body: 'Little data to measure whether a change worked.' },
];

export const vendooPersonas = [
  {
    type: 'Full-time reseller',
    name: 'Maria, 34',
    description: 'Lists 40+ items a week across five marketplaces and runs reselling as her main income.',
    needs: 'Speed, bulk actions and profit numbers she can hand to her accountant.',
  },
  {
    type: 'Part-time reseller',
    name: 'Jason, 28',
    description: 'Flips sneakers and streetwear after his day job, mostly from his phone.',
    needs: 'Listing on the go and a clear view of what sold where.',
  },
  {
    type: 'Casual seller',
    name: 'Linda, 52',
    description: 'Clears out her closet a few times a year and sells on one or two marketplaces.',
    needs: 'A simple flow with no reseller jargon.',
  },
];

export type Support = 'yes' | 'partial' | 'no';

export const competitiveColumns = ['Vendoo', 'Tool A', 'Tool B', 'Spreadsheets'];

export const competitiveRows: { feature: string; values: Support[] }[] = [
  { feature: 'Cross-listing to many marketplaces', values: ['yes', 'yes', 'partial', 'no'] },
  { feature: 'Delist everywhere when an item sells', values: ['yes', 'partial', 'no', 'no'] },
  { feature: 'Inventory tracking', values: ['partial', 'yes', 'partial', 'yes'] },
  { feature: 'Sales and profit analytics', values: ['no', 'partial', 'no', 'partial'] },
  { feature: 'Tax-ready export', values: ['no', 'no', 'no', 'partial'] },
];

export const csvFields = ['Title', 'SKU', 'Cost of goods', 'Sale price', 'Marketplace', 'Date sold', 'Fees', 'Shipping'];

export const analyticsNeeds = [
  {
    title: 'Research and definitions',
    body: 'I defined what to track, compared the tools sellers were already using, and pinned down what those tools got wrong.',
  },
  {
    title: 'What sellers needed',
    body: 'Quick access to sales data in graphs and charts, in a form that would also help at tax time.',
  },
];

export const metricDefinitions = [
  { metric: 'Gross sales', formula: 'Sum of sale prices, before fees' },
  { metric: 'Net profit', formula: 'Sales − cost of goods − marketplace fees − shipping' },
  { metric: 'Sell-through rate', formula: 'Items sold ÷ items listed in the period' },
  { metric: 'Days to sell', formula: 'Average days from listing to sale' },
];

export type AnalyticsRange = 'month' | 'quarter' | 'year';

export const analyticsRanges: { id: AnalyticsRange; label: string; kpis: { label: string; value: string }[]; bars: { label: string; value: number }[] }[] = [
  {
    id: 'month',
    label: 'Month',
    kpis: [
      { label: 'Gross sales', value: '$4,820' },
      { label: 'Net profit', value: '$2,140' },
      { label: 'Items sold', value: '63' },
    ],
    bars: [
      { label: 'eBay', value: 82 },
      { label: 'Poshmark', value: 64 },
      { label: 'Mercari', value: 48 },
      { label: 'Etsy', value: 22 },
      { label: 'Tradesy', value: 14 },
    ],
  },
  {
    id: 'quarter',
    label: 'Quarter',
    kpis: [
      { label: 'Gross sales', value: '$13,960' },
      { label: 'Net profit', value: '$6,310' },
      { label: 'Items sold', value: '181' },
    ],
    bars: [
      { label: 'eBay', value: 70 },
      { label: 'Poshmark', value: 78 },
      { label: 'Mercari', value: 52 },
      { label: 'Etsy', value: 30 },
      { label: 'Tradesy', value: 18 },
    ],
  },
  {
    id: 'year',
    label: 'Year',
    kpis: [
      { label: 'Gross sales', value: '$52,400' },
      { label: 'Net profit', value: '$23,870' },
      { label: 'Items sold', value: '702' },
    ],
    bars: [
      { label: 'eBay', value: 88 },
      { label: 'Poshmark', value: 72 },
      { label: 'Mercari', value: 60 },
      { label: 'Etsy', value: 36 },
      { label: 'Tradesy', value: 20 },
    ],
  },
];

export const vendooResults = [
  { value: '3+ years', label: 'the design stayed in production without a structural redesign' },
  { value: 'Every month', label: 'revenue grew after the changes shipped' },
  { value: 'LogRocket', label: 'set up to track user issues and feed the next features' },
];
